export interface SafetyInput {
    Name: string;
    Position: number;
    Enabled: boolean;
    State: number;
}

export interface SafetyInputCategory {
    Category: string;
    SafetyInputs: SafetyInput[];
}

export const getSafetyInputIcon = (input: SafetyInput) => {
    if (!input.Enabled) {
        return "p-tag-mobile p-tag-darkBlue10"
    } else {
        if (input.State === 0) {
            return "p-tag-mobile p-tag-greenSuccess"
        } else {
            return "p-tag-mobile p-tag-redDanger" 
        }
    }
};
